import React from "react";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { colors } from "styles/colors";
import Button from "shared/Button";
import { togglePamentModal } from "store/modalReducer";
import { toggleModal, isUserLogin } from "store/loginReducer";
import { addGrocery } from "api/api";
import { setInGrocery } from "store/collectionReducer";
import { getOwner } from "store/userReducer/userSelectors";

const AddGrocery = ({ collection }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const isLogin = useSelector(isUserLogin);

  const currentUser = useSelector(getOwner);
  const isUserCreator = collection.collection_creator.id === currentUser.id;
  const isInGrocery = collection.in_grocery;
  const isPaid = collection.paid && !collection.purchased && !isUserCreator;

  const onClick = async () => {
    if (!isLogin) {
      dispatch(toggleModal(true));
    } else if (isPaid) {
      dispatch(togglePamentModal(true));
    } else if (isInGrocery) {
      router.push("/grocery-list");
    } else {
      dispatch(setInGrocery({ isCollection: true }));
      await addGrocery({ type: "collection", id: collection.id });
    }
  };

  return (
    <Button
      color={colors.WHITE}
      textColor={isInGrocery ? colors.GREEN : colors.RED}
      stylType="outline"
      text={isInGrocery ? "In your Grocery List" : "Add to Grocery List"}
      iconRight={isInGrocery ? "check" : "plus"}
      btnSize="larger"
      onClick={onClick}
    />
  );
};

export default AddGrocery;
